var exports = {
  "kL": "GroupInvitesBottomSheet.module__container___MWxkVE",
  "Gv": "GroupInvitesBottomSheet.module__backButton___MWxkVE",
  "j2": "GroupInvitesBottomSheet.module__backIcon___MWxkVE",
  "XG": "GroupInvitesBottomSheet.module__scroller___MWxkVE",
  "Qs": "GroupInvitesBottomSheet.module__content___MWxkVE",
  "g4": "GroupInvitesBottomSheet.module__loadingContainer___MWxkVE",
  "KQ": "GroupInvitesBottomSheet.module__loadingText___MWxkVE",
  "do": "GroupInvitesBottomSheet.module__emptyContainer___MWxkVE",
  "BI": "GroupInvitesBottomSheet.module__emptyText___MWxkVE",
  "IH": "GroupInvitesBottomSheet.module__inviteList___MWxkVE",
  "Lu": "GroupInvitesBottomSheet.module__inviteItem___MWxkVE",
  "EM": "GroupInvitesBottomSheet.module__inviteDetails___MWxkVE",
  "fn": "GroupInvitesBottomSheet.module__inviteUrl___MWxkVE",
  "U5": "GroupInvitesBottomSheet.module__inviteInfo___MWxkVE",
  "R5": "GroupInvitesBottomSheet.module__revokeButton___MWxkVE",
  "kQ": "GroupInvitesBottomSheet.module__revokeIcon___MWxkVE",
};

module.exports = exports;
